<div class="flex h-full flex-col bg-white" data-cy="history-sheet">
  <div class="flex items-center justify-between border-b border-solid border-border-2 px-4 py-3">
    <h2 class="text-base font-semibold">{{ 'store-history.history' | translate }}</h2>

    <button mat-icon-button data-cy="history-close" (click)="closed.emit()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-tab-group
    class="flex-1 overflow-hidden"
    [selectedIndex]="selectedTab()"
    (selectedIndexChange)="selectedTab.set($event)"
  >
    <mat-tab [label]="'store-history.changes' | translate">
      <div class="h-full overflow-y-auto">
        <app-history-changes-tab
          [state]="changesState()"
          (retry)="load()"
          (interacted)="markInteracted()"
          (showSnapshots)="selectedTab.set(1)"
          data-cy="history-changes-tab"
        />
      </div>
    </mat-tab>

    <mat-tab [label]="'store-history.snapshots' | translate">
      <div class="h-full overflow-y-auto">
        <app-history-snapshots-tab (interacted)="markInteracted()" data-cy="history-snapshots-tab" />
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
